// Smoothly scroll the current route's scroll container(s) to the top. Used when
// the user taps the nav link for the route they're already on (bottom nav /
// sidebar / mobile menu) — nav to the same route is a no-op, so this doesn't
// conflict with TanStack's per-route scroll restoration.
export function scrollActiveTabToTop() {
  document
    .querySelectorAll<HTMLElement>('[data-scroll-restoration-id="tab-scroll"]')
    .forEach((el) => el.scrollTo({ top: 0, behavior: 'smooth' }))
}
